// stores/counter.ts
import {defineStore} from 'pinia'
import {ref} from "vue";
import {NotificationEntity} from "@/entities/NotificationEntity";
import UserEntity, {MeEntity} from "@/entities/UserEntity";
import {useApiStore} from "@/stores/apiStore";

export let useUserStore = defineStore('user', () => {

	let {api} = useApiStore();

	let me = ref<MeEntity | null>(null);
	let loaded = ref<boolean>(false);

	let timeout : any = null;
	let active : boolean = false;

	async function update(){

		me.value = await api.getMe();
		loaded.value = true;

	}

	function startUpdating(){

		active = true;

		timeout = setTimeout(async function b(){

			await update();

			if(active){
				timeout = setTimeout(b, 1000);
			}

		}, 1000);


	}

	function stopUpdating(){

		if(timeout){
			clearTimeout(timeout);

			timeout = null;
		}

		active = false;

	}

	return {
		startUpdating,
		stopUpdating,
		update,
		me,
		loaded
	}


});